// extracted by mini-css-extract-plugin
export default {"card-container":"NoteList_card-container__Xg-d9"};